import { Slider } from '@mui/material';
import { isEqual } from 'lodash';
import { useTranslation } from 'next-i18next';
import React, { useEffect, useState } from 'react';
import { ComponentStylingInterface, SignupFormComponentInterface } from '../../../../../interfaces/pagebuilder';
import { useSelector } from '../../../../../reduxToolkit/typedRedux';
import { PageBuilderSettingsSection, PageBuilderSettingsTable } from '../PageBuilderSettingsTable';

const SignupFormStyling = ({ component, onChange }: ComponentStylingInterface<SignupFormComponentInterface>) => {
  const pagebuilder = useSelector((state) => state.common.pagebuilder);
  const fields = pagebuilder.currentaltsignup?.registrationFields ?? useSelector((state) => state.common.registrationFields);

  const [currComponent, setCurrComponent] = useState(component);

  const { t } = useTranslation('pagebuilder');

  useEffect(() => {
    setCurrComponent(component);
  }, [component]);

  const onStyleChange = (newComponent: SignupFormComponentInterface) => {
    onChange(newComponent);
    setCurrComponent(newComponent);
  };
  const hasSelectFields = fields.filter((field) => field.isHidden !== true).some((field) => field.textValueOptions.length > 0);

  const settingSections: PageBuilderSettingsSection[] = [
    {
      name: t('signup-styling'),
      settings: [
        {
          tooltip: t('pagebuilder:tooltip-fields-border-color'),
          label: t('pagebuilder:fields-border-color'),
          type: 'color',
          path: 'customStyling.fieldsBorderColor',
        },
        {
          tooltip: t('pagebuilder:tooltip-signup-fields-text-color'),
          label: t('pagebuilder:signup-fields-text-color'),
          type: 'color',
          path: 'customStyling.fieldsTextColor',
        },
        {
          tooltip: t('pagebuilder:tooltip-select-field-selected-color'),
          label: t('pagebuilder:select-field-selected-color'),
          type: 'color',
          path: 'customStyling.selectFieldSelectedColor',
          visible: hasSelectFields,
        },
      ],
    },
    {
      name: t('signup-button-styling'),
      settings: [
        {
          label: t('pagebuilder:signup-button-color'),
          type: 'color',
          path: 'customStyling.buttonColor',
        },
        {
          label: t('pagebuilder:signup-button-text-color'),
          type: 'color',
          path: 'customStyling.buttonTextColor',
        },
        {
          label: t('pagebuilder:signup-button-width'),
          content: (
            <Slider
              key="buttonWidth"
              name="buttonWidth"
              id="buttonWidth"
              defaultValue={currComponent.customStyling?.buttonWidth || 0}
              onChangeCommitted={(e, value) => {
                const _component: any = {
                  ...currComponent,
                  customStyling: {
                    ...currComponent.customStyling,
                    buttonWidth: value,
                  },
                };
                onStyleChange(_component);
              }}
              scale={(value) => value}
              valueLabelDisplay="auto"
              aria-labelledby="button-width-slider"
              step={20}
              min={0}
              max={900}
              style={{ width: '100%' }}
            />
          ),
        },
        {
          label: t('pagebuilder:signup-button-fontsize'),
          content: (
            <Slider
              key="btnFontSize"
              name="btnFontSize"
              id="btnFontSize"
              defaultValue={currComponent.customStyling?.btnFontSize || 0}
              onChangeCommitted={(e, value) => {
                const _component: any = {
                  ...currComponent,
                  customStyling: {
                    ...currComponent.customStyling,
                    btnFontSize: value,
                  },
                };
                onStyleChange(_component);
              }}
              scale={(value) => value}
              valueLabelDisplay="auto"
              aria-labelledby="font-size-slider"
              step={1}
              min={6}
              max={40}
              style={{ width: '100%' }}
            />
          ),
        },
      ],
    },
  ];

  return <PageBuilderSettingsTable sections={settingSections} onChange={onStyleChange} component={currComponent} showTitleAndDescription={false} />;
};
export default React.memo(SignupFormStyling, (prevprop, newprop) => isEqual(prevprop, newprop));
